import { StoreScheduleListParams } from "../../view/Modules/StoreSchedule/StoreScheduleDataTypes";
import AxiosInstance from "../config/axiosInterceptor";
import { ContentApiRoutes } from "../../navigation/NavConstant";
import { UtilityServices } from "./UtilityServices";
import { messageTypeArr } from "../config/AppConstants";
import { calenderDateToDB, dateFormat } from "../../utils/helpers";

export const StoreScheduleServices = {
  getStoreSchedule: (params: StoreScheduleListParams) => {
    return AxiosInstance.get(ContentApiRoutes.STORE_SCHEDULE, { params });
  },
  getStoreScheduleFromAdmin: (params: StoreScheduleListParams) => {
    return AxiosInstance.get(ContentApiRoutes.STORE_SCHEDULE_FROM_ADMIN, {
      params,
    });
  },
  downloadStoreSchedule: (params: StoreScheduleListParams) => {
    return AxiosInstance.get(ContentApiRoutes.STORE_SCHEDULE, {
      params,
      responseType: "blob", // important
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "store-schedule-download-" +
            dateFormat(params.schedule_date, "dd-MM-yyyy") +
            ".json"
        );
        document.body.appendChild(link);
        link.click();
      })
      .catch((response: any) => {
        UtilityServices.showToaster({
          message: "Some Technical Error Occured or Export Limit Exceeds",
          type: messageTypeArr.error,
        });
      });
  },
};
